/* eslint-disable no-console */
import { register } from 'register-service-worker'
import { usePwa } from '@/composables/usePwa'

const { setNetworkOffline, setWaiting } = usePwa()

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    /** Periodically checks a successful registration so a waiting update becomes visible. */
    registered (registration) {
      // Periodically check for a new version so the update banner can appear.
      setInterval(() => registration.update(), 60 * 60 * 1000)
    },
    /** Hands a waiting worker to the shared PWA state for the update prompt. */
    updated (registration) {
      // A new service worker is waiting → surface the update banner.
      setWaiting(registration)
    },
    /** Marks the app offline when the service-worker runtime detects loss of connectivity. */
    offline () {
      setNetworkOffline(true)
    },
    /** Logs registration failures without interrupting the regular application shell. */
    error (error) {
      console.error('Service worker registration failed:', error)
    }
  })
}
